// extracted by mini-css-extract-plugin
export var cardHeader = "_j6-0";
export var reorderHandle = "_j6-3";
export var titleArea = "_j6-1";
export var titleAreaWithHandle = "_j6-2";